import { PRICING_MODELS, type PricingModel } from '@vy/types';

export function getPricingModelLabel(pricingModel: PricingModel | string | null | undefined): string {
  if (pricingModel === null || pricingModel === undefined) return '--';

  switch (pricingModel) {
    case PRICING_MODELS.PerUnit:
      return 'Per Unit';
    case PRICING_MODELS.Tiers:
      return 'Tiered';
    case PRICING_MODELS.TieredSubscription:
      return 'Tiered Subscription';
    case PRICING_MODELS.CommercialTerms:
      return 'Contract Terms';
    case PRICING_MODELS.Commission:
      return 'Commission';
    case PRICING_MODELS.FixedDeduction:
      return 'Discount';
    case PRICING_MODELS.FixedOneTime:
      return 'One-Time Fee';
    case PRICING_MODELS.PercentageDeduction:
      return 'Percentage Discount';
    case PRICING_MODELS.Refund:
      return 'Refund';
    case PRICING_MODELS.Subscription:
      return 'Subscription';
    default:
      return String(pricingModel);
  }
}
